var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"enable-background":"new 0 0 95 95"},attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 95 95","xml:space":"preserve"}},[_c('line',{staticClass:"line",attrs:{"x1":"0","y1":"48","x2":"95","y2":"48"}}),_vm._v(" "),_c('line',{staticClass:"line",attrs:{"x1":"48","y1":"0","x2":"48","y2":"95"}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13a92aa1","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlusIcon.vue
// module id = null
// module chunks = 